import { firestoreAction, vuexfireMutations } from 'vuexfire'
import Vue from 'vue'
import Vuex from 'vuex'
import firebase from '@firebase/app'
import '@firebase/firestore'
import '@firebase/auth'
import '@firebase/storage'


var config = {
  apiKey: "AIzaSyABNNqFxrkKunK4PiAiC3_Vhk-2aUXiQy8",
  authDomain: "ngdata-28d07.firebaseapp.com",
  databaseURL: "https://ngdata-28d07.firebaseio.com",
  projectId: "ngdata-28d07",
  storageBucket: "ngdata-28d07.appspot.com",
  messagingSenderId: "1088706950013"
}
// first auth reference
firebase.initializeApp(config)

// second auth reference, used to create new users without loggin out Admins 
// automatically
var secondaryApp = firebase.initializeApp(config, "Secondary");

const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()

auth.onAuthStateChanged(function(user) {
  console.log('AuthStateChanged')
  if (user) {
    user.getIdToken(true)
    firebase.auth().currentUser.getIdTokenResult()
    .then((idTokenResult) => {
      console.log(idTokenResult.claims)
    })
    store.commit('set_user_uid', user.uid)
  } else {
    store.commit('logout')
  }
})

Vue.use(Vuex)

var store = new Vuex.Store({
  state: {
    userUid: null,
    userData: null,
    userFiles: [],
    userCurrentClient: null,
    loginRequired: false,
    uploadProgress: 0,
    cancelUpload: false,
    currentFileDocId: null,
    // Admin data
    allClients: [],
    allUsers: []
  },
  getters: {
    userUid: ({userUid}) => userUid,
    userData: ({userData}) => userData,
    userFiles: ({userFiles}) => userFiles,
    userCurrentClient: ({userCurrentClient}) => userCurrentClient,
    loginRequired: ({loginRequired}) => loginRequired,
    uploadProgress: ({uploadProgress}) => uploadProgress,
    currentFileDocId: ({currentFileDocId}) => currentFileDocId,
    // Admin data
    allClients: ({allClients}) => allClients,
    allUsers: ({allUsers}) => allUsers
  },
  mutations: {
    ...vuexfireMutations,
    set_user_uid (state, userId) {
      state.loginRequired = false
      state.userUid = userId 
    },
    set_current_client (state, currentClient) {
      if (typeof currentClient === 'string' || currentClient instanceof String) {
        var client
        if (state.allClients && state.allClients.length > 0) {
          client = state.allClients.filter(function (obj) {
            return obj.id == currentClient
          })[0]
          state.userCurrentClient = client
        } else {
          client = state.userData.clients.filter(function (obj) {
            return obj.client.id == currentClient
          })[0]
          state.userCurrentClient = client.client
        }
      } else {
        state.userCurrentClient = currentClient
      }
    },
    logout (state) {
        state.loginRequired = true
        state.userUid = null
    },
    update_upload_progress (state, payload) {
      state.uploadProgress = payload.progress
    },
    set_cancel_upload (state, payload){
      state.cancelUpload = payload.cancel
    },
    set_current_file_doc_id (state, id) {
      state.currentFileDocId = id
    }
  },
  methods:{

  },
  actions: {
    async login({ commit }, payload) {
      try {
          await firebase.auth().signInWithEmailAndPassword(payload.user, payload.password).then((profile) => {
            commit('set_user_uid', profile.user.uid)
          })
      } catch(error) {
          return error
      }
    },
    async logout() {
      try {
        await firebase.auth().signOut()
      } catch(error) {
        return error
      }
    },
    async getUserClients(payload){
      var uid = payload.uid;
      db.collection(`users/${uid}/clients`).get()
      .then((querySnapshot) => {
          return querySnapshot
      })
    },
    async createClient({state}, payload) {
      db.collection('clients').add({
        name: payload.name
      })

    },
    async updateClient({state}, payload) {
      db.collection('clients').doc(payload.id).set({
        name: payload.name
      }, { merge: true })

    },
    async deleteClient({state}, payload) {
      db.collection('clients').doc(payload.id).delete()
    },
    async deleteUser({state}, payload) {
      db.collection('users').doc(payload.id).delete()
    },
    async updateFileTypes({state}, payload) {
      db.collection('clients').doc(payload.id).set({
        fileTypes: payload.fileTypes
      }, { merge: true })
    },
    async createUserAuth({state}, payload){
      const randomPassword = payload.password
      const name = payload.name
      const lastname = payload.lastname
      const email = payload.email
      const isAdmin = payload.isAdmin
      const clientsNamesAndIDs = payload.clientsNamesAndIDs
      const selectedClients = payload.selectedClients
      const ownedClients = payload.ownedClients
      await secondaryApp.auth().createUserWithEmailAndPassword(email, randomPassword).then(userCredential => {
        console.log("User " + userCredential.user.uid + " created successfully!");
        db.collection('users').doc(userCredential.user.uid).set({
            name: name,
            lastname: lastname,
            email: email,
            admin: isAdmin  
        })
        return userCredential
      })
      .then(userCredential => {
        var clientArray =[]
        for(var i = 0; i < selectedClients.length; i++){
          let selectedClientName  = selectedClients[i]
          for(var j = 0; j < clientsNamesAndIDs.length; j++){
            if(clientsNamesAndIDs[j].name == selectedClientName){
              var clientObject = {}
              clientObject.client = db.doc('/clients/' + clientsNamesAndIDs[j].id)
              // var clientRoles = []
              var clientRoles = ''
              // assigning client roles depending on user choice
              if(ownedClients.includes(selectedClientName)){
                clientRoles = 'owner'
              } else{
                clientRoles += 'viewer'
              }
              // console.log(clientRoles.length)
              // clientObject.role = `${clientRoles[0]}, ${clientRoles[1]}`
              clientObject.role = clientRoles
              clientArray.push(clientObject)
            }
          }
        }
        db.collection(`users`).doc(userCredential.user.uid).update({
          clients: clientArray
        })
        // triggers reset password by email
        // send random password to user
        // force changing password
        // TODO: force to change password 
        // secondaryApp.auth().sendPasswordResetEmail(email)
        // secondaryApp.auth().currentUser.sendEmailVerification()
        .then(() => {
        })
        .catch((error) => {
        // Some error occurred.
        });
        console.log(clientArray)  
      })    
    },
    /* Old version checking in storage instead of db, now implemented directly in the view, kept as reference 
      checkIfFileExists({ state }, payload) {
      return new Promise((resolve, reject) => {
        storage.ref('uploads/' + state.userCurrentClient.id + '/' + state.userUid + '/' + payload.file.name).getDownloadURL()
        // File exists
        .then(function () {
          console.log('File exists: ', payload.file.name)
          resolve()
        }, function () {
          console.log('File does not exist: ', payload.file.name)
          reject()
        })
      })
    }, */
    cancelUpload({ commit }) {
      commit('set_cancel_upload', {
        cancel: true
      })
    },
    resetUploadProgress({ commit }) {
      commit('update_upload_progress', {
        progress: 0
      })
    },
    uploadFile({ state, commit }, payload) {
      commit('update_upload_progress', {
        progress: 0
      })
      db.collection('clients').doc(state.userCurrentClient.id).collection('files').add({
        filename: payload.file.name,
        owner_id: state.userUid,
        owner: state.userData.name + ' ' + state.userData.lastname,
        upload_date: firebase.firestore.FieldValue.serverTimestamp(),
      }).then(docRef => {
        commit('set_current_file_doc_id', docRef.id)
        var metadata = {
          customMetadata: {
            'fileDocId': docRef.id
          }
        }
        var uploadTask = storage.ref().child('uploads/' + state.userCurrentClient.id + '/' + state.userUid + '/' + payload.file.name).put(payload.file, metadata)
          uploadTask.on('state_changed', function(snapshot){
            if (state.cancelUpload) {
              uploadTask.cancel()
              commit('set_cancel_upload', {
                cancel: false
              })
            }
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            commit('update_upload_progress', {
              progress: progress
            })
          }, function (error) {
            console.log(error)
          }, function () {
            console.log('File uploaded: ' + payload.file.name)
          })
      })
    },
    confirmFile({ state }, payload) {
      db.collection('clients').doc(state.userCurrentClient.id).collection('files').doc(state.currentFileDocId).set({
          description: payload.description,
          dateColumnMode: payload.dateColumnMode,
          type: payload.type,
          columnMappings: payload.columnMappings,
          columnComments: payload.columnComments,
          last_edit_date: firebase.firestore.FieldValue.serverTimestamp(),
        }, { merge: true })
    },
    downloadFile({ state }, payload) {
      storage.ref('uploads/' + state.userCurrentClient.id + '/' + payload.owner + '/' + payload.filename).getDownloadURL().then(function(downloadURL) {
        var xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.onload = function(event) {
          var blob = xhr.response
          let a = document.createElement("a")
          a.style = "display: none"
          document.body.appendChild(a)
          //Create a DOMString representing the blob and point the link element towards it
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = payload.filename
          //programatically click the link to trigger the download
          a.click()
          //release the reference to the file by revoking the Object URL
          window.URL.revokeObjectURL(url)
        };
        xhr.open('GET', downloadURL)
        xhr.send()
      })
    },
    deleteFile ({ state }, payload) {
      storage.ref('uploads/' + state.userCurrentClient.id + '/' + payload.owner + '/' + payload.filename).delete().then(function() {
        console.log("Document successfully deleted from storage: ", payload.filename)
      }).catch(function(error) {
        console.log("Error removing document from storage: ", error)
      })
      db.collection('clients').doc(state.userCurrentClient.id).collection('files').doc(payload.fileId).delete().then(function() {
        console.log("Document successfully deleted from db: ", payload.filename)
      }).catch(function(error) {
          console.error("Error removing document from db: ", error)
      })
    },
    deleteUploadedFile ({ state }, payload) {
      storage.ref('uploads/' + state.userCurrentClient.id + '/' + state.userUid + '/' + payload.file.name).delete().then(function() {
        console.log('Deleted last uploaded file from Storage: ', payload.file.name)
        db.collection('clients').doc(state.userCurrentClient.id).collection('files').doc(state.currentFileDocId).delete().then(() => {
          console.log('Deleted last uploaded file from DB: ', payload.file.name)
        })
      }).catch(function(error) {
        console.log("Error removing document: ", error)
      })
    },
    initStore: firestoreAction( async ({ bindFirestoreRef, state, dispatch, commit }) => {
      await bindFirestoreRef('userData', db.collection('users').doc(state.userUid))
      .then( async () => {
        var client
        if ('admin' in state.userData && state.userData['admin'] === true) {
          console.log("Admin mode enabled")
          await dispatch('initAdminStore')
          // Select already selected client or, if there's no selected client, select the first one
          client = state.allClients[0]
          if (state.userCurrentClient) {
            client = state.allClients.filter(function (obj) {
              return obj.id == state.userCurrentClient.id
            })[0]
          }
        } else {
          console.log("Admin mode disabled")
          // Select already selected client or, if there's no selected client, select the first one
          client = state.userData.clients[0].client
          if (state.userCurrentClient) {
            client = state.userData.clients.filter(function (obj) {
              return obj.client.id == state.userCurrentClient.id
            })[0].client
          }
        }
        commit('set_current_client', client)
        // if ('clients' in state.userData && state.userData.clients.length > 0 && 'client' in client && 'id' in client) {
        if (state.userCurrentClient && 'id' in state.userCurrentClient) {
          // await bindFirestoreRef('userFiles', db.collection('clients').doc(state.userCurrentClient.id).collection('files').where('owner', '==', db.collection('users').doc(state.userUid)))
          // await bindFirestoreRef('userFiles', db.collection('clients').doc(state.userCurrentClient.id).collection('files'))
          await bindFirestoreRef('userFiles', db.collection('clients').doc(state.userCurrentClient.id).collection('files'))
        }
        
        // Delete unconfirmed files on startup
        if ('id' in client) {
          db.collection('clients').doc(client.id).collection('files').get().then(function (snapshot) {
            snapshot.forEach(doc => {
              var data = doc.data()
              if (!('description' in data) || !('dateColumnMode' in data)) {
                dispatch('deleteFile', {
                  owner: data.owner_id,
                  filename: data.filename,
                  fileId: doc.id
                })
              }
            })
          })
        }
      })
    }),
    initAdminStore: firestoreAction( async ({ bindFirestoreRef }) => {
      console.log('AdminStore initialized')
      await bindFirestoreRef('allClients', db.collection('clients'))
      .then( async () => {
        await bindFirestoreRef('allUsers', db.collection('users'), { maxRefDepth: 10 })
      })
    })
  },
  strict: true
})

export default store